import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

export const withReduxProvider = (store, persistor) => (BaseComponent) => (props) =>
  (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BaseComponent {...props} />
      </PersistGate>
    </Provider>
  );
